/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs.js'
import * as FeedDefs from '../feed/defs.defs.js'

const $nsid = 'app.bsky.bookmark.defs'

export { $nsid }

/** Object used to store bookmark data in stash. */
type Bookmark = {
  $type?: 'app.bsky.bookmark.defs#bookmark'

  /**
   * A strong ref to the record to be bookmarked. Currently, only `app.bsky.feed.post` records are supported.
   */
  subject: RepoStrongRef.Main
}

export type { Bookmark }

/** Object used to store bookmark data in stash. */
const bookmark = /*#__PURE__*/ l.typedObject<Bookmark>(
  $nsid,
  'bookmark',
  /*#__PURE__*/ l.object({
    subject: /*#__PURE__*/ l.ref<RepoStrongRef.Main>(
      (() => RepoStrongRef.main) as any,
    ),
  }),
)

export { bookmark }

type BookmarkView = {
  $type?: 'app.bsky.bookmark.defs#bookmarkView'

  /**
   * A strong ref to the bookmarked record.
   */
  subject: RepoStrongRef.Main
  createdAt?: l.DatetimeString
  item:
    | l.$Typed<FeedDefs.BlockedPost>
    | l.$Typed<FeedDefs.NotFoundPost>
    | l.$Typed<FeedDefs.PostView>
    | l.Unknown$TypedObject
}

export type { BookmarkView }

const bookmarkView = /*#__PURE__*/ l.typedObject<BookmarkView>(
  $nsid,
  'bookmarkView',
  /*#__PURE__*/ l.object({
    subject: /*#__PURE__*/ l.ref<RepoStrongRef.Main>(
      (() => RepoStrongRef.main) as any,
    ),
    createdAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    item: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<FeedDefs.BlockedPost>(
          (() => FeedDefs.blockedPost) as any,
        ),
        /*#__PURE__*/ l.typedRef<FeedDefs.NotFoundPost>(
          (() => FeedDefs.notFoundPost) as any,
        ),
        /*#__PURE__*/ l.typedRef<FeedDefs.PostView>(
          (() => FeedDefs.postView) as any,
        ),
      ],
      false,
    ),
  }),
)

export { bookmarkView }
